import { decide, resolveTurn, everyoneHasDecided } from './turnActions';
import { startRound } from './roundActions';
import { PHASES } from '../constants';

// The engine's one entry point, same shape as the sibling games:
// dispatch(state, action) -> newState. Pure, plain-JSON in and out.

export const ACTIONS = {
  /** One player's secret torch-or-camp choice. */
  DECIDE: 'DECIDE',
  /** Everybody has chosen; play the turn out. */
  RESOLVE_TURN: 'RESOLVE_TURN',
  /** Open the next temple after a round summary has been read. */
  START_ROUND: 'START_ROUND',
};

export const dispatch = (state, action) => {
  switch (action.type) {
    case ACTIONS.DECIDE:
      if (state.meta.roundOver || state.meta.phase === PHASES.FINISHED) return state;
      return decide(state, action);

    case ACTIONS.RESOLVE_TURN:
      if (!everyoneHasDecided(state)) return state;
      return resolveTurn(state);

    case ACTIONS.START_ROUND:
      // Only ever legal between rounds, which is also what stops a double
      // click (or two clients racing) from dealing two expeditions.
      if (!state.meta.roundOver || state.meta.phase === PHASES.FINISHED) return state;
      return startRound(state);

    default:
      return state;
  }
};

export { decide, resolveTurn, everyoneHasDecided, startRound };
